import gql from 'graphql-tag';
import { CREATOR_DISCOVERY_SETTINGS_FRAGMENT } from './fragments/CreatorDiscoverySettingsFragment';

export const GET_CREATOR_DISCOVERY_SETTINGS_QUERY = gql`
  query GetCreatorDiscoverySettings {
    getCreatorDiscoverySettings {
      ...CreatorDiscoverySettingsFragment
    }
  }
  ${CREATOR_DISCOVERY_SETTINGS_FRAGMENT}
`;
